import {
  GENERATE_QUESTION,
  GENERATE_QUESTION_SUCCESS,
  GENERATE_QUESTION_FAILURE,
  GET_QUESTIONS,
  GET_QUESTIONS_SUCCESS,
  GET_QUESTIONS_FAILURE,
  POST_QUESTION,
  POST_QUESTION_SUCCESS,
  POST_QUESTION_FAILURE,
  GET_QUESTION_LIBRARY,
  GET_QUESTION_LIBRARY_SUCCESS,
  GET_QUESTION_LIBRARY_FAILURE,
} from "../action/types";
const INIT_STATE = {
  loading: false,
  lists: null,
  questionLibrary: [],
  libraryLoading: false,
};
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_QUESTIONS:
      return { ...state, loading: true };
    case GET_QUESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        lists: action.payload,
      };
    case GET_QUESTIONS_FAILURE:
      return { ...state, loading: false };

    case POST_QUESTION:
      return { ...state, loading: true };
    case POST_QUESTION_SUCCESS:
      return { ...state, loading: false };
    case POST_QUESTION_FAILURE:
      return { ...state, loading: false };

    case GENERATE_QUESTION:
      return { ...state, loading: false };
    case GENERATE_QUESTION_SUCCESS:
      return { ...state, loading: false };
    case GENERATE_QUESTION_FAILURE:
      return { ...state, loading: false };

    case GET_QUESTION_LIBRARY:
      return { ...state, libraryLoading: true };
    case GET_QUESTION_LIBRARY_SUCCESS:
      return {
        ...state,
        libraryLoading: false,
        questionLibrary: action.payload?.questions,
      };
    case GET_QUESTION_LIBRARY_FAILURE:
      return { ...state, libraryLoading: false };

    default:
      return state;
  }
};
